import * as React from "react";
import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import "./Login.scss";
import { useMediaQuery, useTheme } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import lightlogo from "../../Img/light-mode-logo.png";
import usercalls from "../../Axios";
import consts from "../../constant";
import { toast, ToastContainer } from "react-toastify";
import AuthLeft from "./AuthLeft";
import AuthHeader from "./AuthHeader";
import Loader from "../Loader";

export default function Resend() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  const navigate = useNavigate();
  const [email, setEmail] = useState();
  const [load, setLoad] = useState(false);
  const path = usercalls();

  // const handleSubmit = (event) => {
  //     event.preventDefault();
  //     const data = new FormData(event.currentTarget);
  //     console.log({
  //         email: data.get("email"),
  //         password: data.get("password"),
  //     });
  // };

  const handleSubmit = async () => {
    try {
      setLoad(true);
      const url = `${consts.BackendUrl}/users/resendemail`;
      const payload = {
        email: email,
      };
      const response = await path.postCallWithoutAuthToken({ url, payload });
      const result = await response.json();
      if (result.success) {
        toast.success(result.message);
        localStorage.setItem("email", email);
        setTimeout(() => {
          setLoad(false);
          navigate("/verify");
        }, 2000);
      } else {
        setLoad(false);
        toast.error(result.message);
      }
    } catch (error) {
      setLoad(false);
      console.log("🚀 ~ forgotpass ~ error:", error);
    }
  };

  return (
    <>
      {/* <AuthHeader/> */}
      <ToastContainer />
      <div className="register">
        {load && <Loader />}
        <Grid
          container
          component="main"
          sx={{
            justifyContent: "center",
            alignItems: "center",
            height: !lg && "100vh",
          }}
          className={!md ? "medium" : ""}
        >
          {lg && (
            <Grid item xs={12} sm={12} md={6} lg={5.5}>
              <AuthLeft />
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={12} lg={6.5}>
            <Box
              sx={{
                my: md && 3,
                mx: md && 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                // padding: '28px 25px',
                maxWidth: "700px",
                margin: "0 auto",
                padding: "10px",
              }}
            >
              <Typography
                component="h1"
                variant="h5"
                className="text-center c-accout"
                sx={{ mt: 1, mb: 3 }}
              >
                Resend Verification Email?
              </Typography>
              <Typography className="authe-common">
                Enter the email address you used when you joined and we'll send
                you account activation link to activate your account.
              </Typography>
              <Box
                // component="form"
                // noValidate
                // onSubmit={handleSubmit}
                sx={{ mt: 1, width: "100%" }}
              >
                <div className="email-fill" style={{ width: lg && "80%" }}>
                  <div className="email-name">
                    Email<span className="required"> * </span>
                  </div>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    // label="Email Address"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                </div>

                <div className="common-btn">
                  {load ? (
                    <Button type="submit" fullWidth sx={{ mt: 3, mb: 2 }}>
                      Processing...
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      fullWidth
                      sx={{ mt: 3, mb: 2 }}
                      onClick={() => {
                        handleSubmit();
                      }}
                    >
                      Resend
                    </Button>
                  )}
                </div>

                <div className="text-center accnt-sign mt-10">
                  <Link to="/register" variant="body2">
                    Don't have an account? <span>Sign Up</span>
                  </Link>
                </div>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
